import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'

//store
import store from '../store/index.js'
// import { component } from 'vue/types/umd.js'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// ---------------------------------------------------------------------------
// Pelacakan halaman untuk Google Tag Manager / GA4.
//
// Situs ini SPA: perpindahan halaman TIDAK memuat ulang dokumen, sehingga tanpa
// kode di bawah ini GA4 hanya mencatat halaman PERTAMA yang dibuka.
//
// Setiap ganti halaman kita dorong satu event `page_view` ke dataLayer.
// Di UI GTM buatlah Trigger: Custom Event dengan nama `page_view`.
//
// PENTING: jangan memakai trigger "History Change" untuk GA4, karena akan
// terhitung dua kali bersama event ini.
// ---------------------------------------------------------------------------
router.afterEach((to) => {
  Vue.nextTick(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'page_view',
      page_path: to.fullPath,
      page_location: window.location.href,
      page_title: document.title,
    })
  })
})

export default router
